//垫付款信息管理
import { contractApi } from "@/axios";
//获取垫付款信息
export function getAdvancePage(params, sendData) {
    return contractApi({
        url: '/advance-payment-info/page',
        method: 'post',
        data: sendData,
        params: params
    })
}
//添加垫付款信息
export function addAdvance(data) {
    return contractApi({
        url: '/advance-payment-info',
        method: 'post',
        data: data
    })
}
//修改垫付款信息
export function editAdvance(data) {
    return contractApi({
        url: '/advance-payment-info',
        method: 'put',
        data: data
    })
}
//垫付款信息认领
export function claimAdvance(data) {
    return contractApi({
        url: '/advance-payment-info/claim-contract',
        method: 'put',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//垫付款退款
export function refundAdvance(data) {
    return contractApi({
        url: '/advance-payment-info/refund',
        method: 'put',
        data: data
    })
}
//删除待认领垫付款
export function deleteAdvance(params) {
    return contractApi({
        url: '/advance-payment-info',
        method: 'delete',
        params: params
    })
}
//删除垫付款记录
export function deleteAdvanceRecord(params) {
    return contractApi({
        url: '/advance-payment-info/soft-delete',
        method: 'put',
        params: params
    })
}